



































































































































































import { Component, Vue } from "vue-property-decorator";

import { Getter } from "vuex-class";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";

import { api as deskApi } from "../../store/modules/desk";
import { Dictionary } from "lodash";
import { FriendRef, GameMode } from "@dokogd/shared";
import { ROUTE_NAMES } from "../../router/routenames";

@Component({ components: { DoKoHtmlDialog, DoKoBtn } })
export default class DoKoRestrictoinPovertyFox extends Vue {
  textMap = {
    solo: "Fleischloser",
    "solo-Q": "Damensolo",
    "solo-J": "Bubensolo",
    "solo-♣": "Farbensolo Kreuz",
    "solo-♠": "Farbensolo Pik",
    "solo-♥": "Farbensolo Herz",
    "solo-♦": "Farbensolo Karo",
  };

  @Getter(deskApi.getters.getMappedUsers, { namespace: deskApi.namespace })
  mappedPlayer!: Dictionary<FriendRef>;

  @Getter(deskApi.getters.getTableStats, { namespace: deskApi.namespace })
  tableStats!: null | {
    participants: FriendRef;
    stats: {
      gameIdx: number;
      lead: string;
      firstCardBy: string;
      gameNo: number;
      roundNo: number;
      gamePoints: number;
      mode: GameMode;
      isSolo: boolean;
      ramFactor: number;
      playerPoints: {
        delta: number | null;
        total: number;
      }[];
    }[];
    total: number[];
    deskPoints: number;
  };

  get deskPoints(): number {
    return this.tableStats?.deskPoints ?? 0;
  }

  get stats() {
    return [...(this.tableStats?.stats ?? [])].reverse();
  }
  get totals() {
    return this.tableStats?.total ?? [];
  }
  get players() {
    return this.tableStats?.participants ?? [];
  }

  navToGame(gameNo: number) {
    this.$router.push({
      name: ROUTE_NAMES.GAMERESULT,
      params: {
        gameNo: String(gameNo),
      },
    });
  }
}
